import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-manage-OcrTemplatecategory',
  templateUrl: './manage-OcrTemplatecategory.component.html',
  styleUrls: ['./manage-OcrTemplatecategory.component.scss']
})
export class ManageOCRTemplateCategoryComponent implements OnInit { 
  
  formDialog: FormGroup;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
  };  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  currentUser: any;
  organizationId: string;
  databaseId: string;
  responseHolder: any;  
  value = '';
  filterText: any;   
  totalCount: any;
  paginatorTotalLength: any;
  pageIndex: any;
  pageSize: any;
  currentData: PageEvent;  
  OfficeIDList: any=[];
  myOfficeID: any;
  spinner:boolean=false;
  selectedCategoryID:number=0;
  ShowNoRecordFound:boolean=false;
  categoryList: any[] = [];
  masterTemplateList: any[] = [];
  categoryName:string="";
  ocrTemplateCategoryID:number=0;

  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService, private toastr: ToastrService,
     private statusConst: StatusConstant, private reusableClass: ReusableClasses, private dialog: MatDialog,
     private settingsService: SettingService, private encryptionAlgo: EncryptionService,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID);
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }

  ngOnInit(): void {
    let group = {};
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('categoryName',this.formBuilder.control(''));    
    this.getOCRTempCategoryList();
  }

   // For Get All OCR Temp Category List
   getOCRTempCategoryList(){
    var ReqModel = {
      type: this.categoryTypeForTaskTemplates, // 0 For My Templates
      isCategoriesOnly: true,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)      
    }
     this.loaderService.show();
     this.settingsService.getOCRTemplateCategories(ReqModel).subscribe(response => {
     if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
           if(this.responseHolder.data!=null){
              this.categoryList=this.responseHolder.data;     
              if(this.categoryList.length>0){              
                this.ShowNoRecordFound=false;
             }else{
                this.ShowNoRecordFound=true;
              } 
             }
         }else{
          this.categoryList=[];
          this.ShowNoRecordFound=true;
          this.loaderService.hide();
         }
       }else{
        this.categoryList=[];
        this.ShowNoRecordFound=true;
        this.loaderService.hide();
       }
     });
   }
   
    // //For  Open Pop (Add Category)
    //  openDialogAdd(templateRef: TemplateRef<any>) {
    //   this.formDialog.markAsPristine();
    //   this.formDialog.controls.categoryName.setValue("");
    //   this.ocrTemplateCategoryID=0;
    //   this.dialog.open(templateRef, {
    //   });
    //  }

   //For  Open Pop (Update Category)
   openDialogUpdateType(templateRef: TemplateRef<any>, type: any) {
    this.formDialog.markAsPristine();
    this.formDialog.controls.categoryName.setValue(type.ocrTemplateCategoryName);
    this.ocrTemplateCategoryID=type.ocrTemplateCategoryID;
    this.dialog.open(templateRef, {
    });
   }
 
    // // For Add Category name
    // AddCategoryNameDetails(data) {
    //   this.spinner=true;
    //   this.formDialog.markAsPristine();   
    //   var ReqModel = {
    //       categoryID: 0,//this.categoryID,
    //       name: data.categoryName.trim(),
    //       actionType: MasterTemplateCategory.Save,
    //       userId: this.currentUser.UID,
    //       organizationID: Number(this.organizationId),
    //       officeIDList:this.OfficeIDList,
    //       officeID:this.myOfficeID,
    //       databaseID: Number(this.databaseId),
    //   }
    //   this.settingsService.manageFormTemplateOrganizationCategory(ReqModel).subscribe(response => {
    //     if (response != undefined) {
    //       this.spinner=false;      
    //       this.responseHolder = response;
    //       if (this.responseHolder.status == this.statusConst.statusSuccess){
    //         this.dialog.closeAll();
    //         this.getCategoryList();
    //         this.toastr.success('Category name added successfully.', '', {
    //           timeOut: 3000,
    //         });
    //       }else{
    //         this.toastr.warning('Category already exist.', '', {
    //           timeOut: 2000,
    //         });
    //         this.spinner=false;         
    //       }
    //     }else{
    //       this.spinner=false;       
    //     }
    //   });
    //  }

   // For Update Category name
   UpdateCategoryNameDetails(data) {
    this.spinner=true;
    this.formDialog.markAsPristine();   
    var ReqModel = {
        ocrTemplateCategoryID: this.ocrTemplateCategoryID,
        ocrTemplateCategoryName: data.categoryName.trim(),       
        userId: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeIDList:this.OfficeIDList,
        officeID:this.myOfficeID,
        databaseID: Number(this.databaseId),
    }
    this.settingsService.renameOCRTemplateCategory(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.spinner=false;      
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess){         
          this.toastr.success('Category name updated successfully.', '', {
            timeOut: 3000,
          });         
          this.getOCRTempCategoryList();
          this.dialog.closeAll();
        }else{
          this.toastr.warning('Category already exist.', '', {
            timeOut: 2000,
          });
          this.spinner=false;         
        }
      }else{
        this.spinner=false;       
      }
    });
   }

   // For Update OCR Category Status
   UpdateStatusToggle(type: any,event: any) {
    this.loaderService.show();
    var ReqModel = {
      activate: event.checked,     
      ocRtemplateCategoryID:type.ocrTemplateCategoryID,
      userId: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeIDList:this.OfficeIDList,
      officeID:this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.settingsService.activateOCRCategoryTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {          
          this.toastr.success('Category status updated successfully.', '', {
            timeOut: 3000,
          });
          this.getOCRTempCategoryList(); 
          this.loaderService.hide();
        }else{
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
   }

   // For Delete OCR Category
   DeleteCategory(type: any) {  
    var message = `Are you sure you want to delete?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();
        var ReqModel = {
          ocrTemplateCategoryIDs: [type.ocrTemplateCategoryID],          
          userId: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          officeIDList:this.OfficeIDList,
          officeID:this.myOfficeID,
          databaseID: Number(this.databaseId),
        }     
        this.settingsService.removeOCRTemplateCategories(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {             
              this.toastr.success('Category deleted successfully.', '', {
                timeOut: 3000,
              });
              this.getOCRTempCategoryList();
              this.loaderService.hide();
            }
          }
          else{
            this.loaderService.hide();
          }
        });
      }
    });
   }
   

   close() {
    this.dialog.closeAll();
   }

   categoryTypeForTaskTemplates:number=0;

  OnChnageCategory($event) {

    if($event.value == "My Template"){
      this.categoryTypeForTaskTemplates=0;
    }
    if($event.value == "Organization"){
      this.categoryTypeForTaskTemplates=2;     
    }   
    this.getOCRTempCategoryList();   
  }

  //  Search(filterValue) {
  //   this.filterText = filterValue.trimLeft();
  //   this.pageModelData.searchValue = filterValue.trim();
  //  // this.getTypeList(this.pageModelData);
  //  }

  //  clearFilter(){
  //   this.value = "";
  //   this.filterText = "";
  //   this.pageModelData.searchValue = this.filterText.trim();
  //  // this.getTypeList(this.pageModelData);
  //   }
     
}
